import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SegmentDiscountsComponent } from './segment-discounts/segment-discounts.component';

const routes: Routes = [
  {
    path: '',
    component: SegmentDiscountsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SegmentDiscountsRoutingModule {}
